import { DateTime } from "luxon";
import i18n from "../i18n";
import ValidationResult from "../interfaces/api/validation-result";

export const validateStartDate = (startDate: DateTime): ValidationResult => {
  if (!isValidDate(startDate)) {
    return {
      isValid: false,
      error: i18n.t("excludedDates-validationerror-date-isInvalid"),
    };
  }
  return { isValid: true, error: null };
};

export const validateEndDate = (endDate: DateTime, startDate: DateTime): ValidationResult => {
  if (!isValidDate(endDate)) {
    return {
      isValid: false,
      error: i18n.t("excludedDates-validationerror-date-isInvalid"),
    };
  }
  if (endDate < startDate) {
    return {
      isValid: false,
      error: i18n.t("excludedDates-validationerror-endDate-isLessThan"),
    };
  }
  return { isValid: true, error: null };
};

export const validateReason = (reason: string): ValidationResult => {
  if (reason.length < 1) {
    return {
      isValid: false,
      error: i18n.t("excludedDates-validationerror-reason-empty"),
    };
  }

  return { isValid: true, error: null };
};

const isValidDate = (d: any) => {
  return !isNaN(d);
};
